import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/gms-myprofile-blue-01.svg")